export default "__VITE_ASSET__BGVToJCf__"